export const api = "https://ecomm-server-gih1.onrender.com/api"